import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from 'components/Spinner';
import Message from 'components/Message';
import ScrollToTop from 'components/ScrollToTop';

const paddingSpacingMultiplier = 2;

export const FullWidthPageContent = styled.div`
  margin: 0 ${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
`;

const StyledLayout = styled.div`
  position: relative;
  max-width: ${({ theme }) => theme.breakpoints.md}px;
  margin: 0 auto;

  > header {
    position: sticky;
    top: 0px;
    z-index: ${({ theme }) => theme.zIndex.header};
  }
`;

const LayoutContent = styled.main`
  padding: ${({ theme }) => theme.spacing * paddingSpacingMultiplier}px;
  padding-top:${({ theme }) => theme.spacing * 2 * paddingSpacingMultiplier}px;
  background-color: ${({ theme }) => theme.palette.background.secondary};

  >* {
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
  }

  >${FullWidthPageContent}:first-child{
    margin-top:${({ theme }) => theme.spacing * -(2 * paddingSpacingMultiplier)}px;
  }
  >${FullWidthPageContent}:last-child{
    margin-bottom:${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
  }
`;

const SingleColumnLayout = ({
  className, header, menu, message, children, appBusy,
}) => {
  const classes = ['SingleColumnLayout'];
  if (className) {
    classes.push(className);
  }

  return (
    <StyledLayout className={classes.join(' ')}>
      {appBusy && <Spinner />}
      {menu ? <>{menu}</> : null}
      {header && <header>{header}</header>}
      {message}
      <LayoutContent>
        <ScrollToTop containerElem={window.document.querySelector('#root')} />
        {children}
      </LayoutContent>
    </StyledLayout>
  );
};

SingleColumnLayout.displayName = 'SingleColumnLayout';

SingleColumnLayout.propTypes = {
  header: PropTypes.element,
  menu: PropTypes.element,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  className: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.shape({
      type: Message.propTypes.type,
      nonDismissable: PropTypes.bool,
      onDismiss: PropTypes.func,
      message: PropTypes.node,
    }),
    PropTypes.element,
  ]),
  appBusy: PropTypes.bool,
};

SingleColumnLayout.defaultProps = {
  header: null,
  menu: null,
  className: null,
  message: null,
  appBusy: false,
};

export default SingleColumnLayout;
